import { render, staticRenderFns } from "./TeamCarrousel.vue?vue&type=template&id=45a6c739&scoped=true&"
import script from "./TeamCarrousel.vue?vue&type=script&lang=ts&"
export * from "./TeamCarrousel.vue?vue&type=script&lang=ts&"
import style0 from "./TeamCarrousel.vue?vue&type=style&index=0&id=45a6c739&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a6c739",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VImg,VLayout,VRow})
